(ns bleene.utils
  (:require
   [applied-science.js-interop :as jsi]
   [react :as react]
   [re-frame.core :as re-frame]))


(defn query
  ([query-map]
   @(re-frame/subscribe [:app/query query-map {}]))

  ([query-map params-map]
   @(re-frame/subscribe [:app/query query-map params-map])))


(defn event->points [event]
  (let [target (jsi/get event :target)
        stage  (jsi/call target :getStage)
        point  (jsi/call stage :getPointerPosition)]
    {:point-x (jsi/get point :x)
     :point-y (jsi/get point :y)
     :scale   (jsi/call stage :scaleX)
     :stage-x (jsi/call stage :x)
     :stage-y (jsi/call stage :y)}))


(defn event->position [event]
  (let [{:keys [point-x point-y scale stage-x stage-y]}
        (event->points event)]
    {:x (/ (- point-x stage-x) scale)
     :y (/ (- point-y stage-y) scale)}))


(defn cljfy-value [value]
  (js->clj value :keywordize-keys true))


(defn context [react-context]
  (let [value (react/useContext react-context)]
    (cljfy-value value)))


(defn calculate-rect
  ([nodes]
   (calculate-rect nodes {}))

  ([nodes {:keys [start-x start-y end-x end-y]
           :or   {start-x 0 start-y 0 end-x 0 end-y 0}}]
   (let [start-point         (first nodes)
         initial-coordinates {:start-x (:x start-point)
                              :start-y (:y start-point)
                              :end-x   (:x start-point)
                              :end-y   (:y start-point)}
         points              (reduce (fn [{:keys [start-x start-y end-x end-y] :as acc} {:keys [x y]}]
                                       (cond-> acc
                                               (< x start-x)
                                               (assoc :start-x x)

                                               (and (> x start-x) (> x end-x))
                                               (assoc :end-x x)

                                               (< y start-y)
                                               (assoc :start-y y)

                                               (and (> y start-y) (> y end-y))
                                               (assoc :end-y y)))
                                     initial-coordinates
                                     nodes)
         padded-points       (-> points
                                 (update :start-x - start-x)
                                 (update :start-y - start-y)
                                 (update :end-x + end-x)
                                 (update :end-y + end-y))
         width               (- (:end-x padded-points) (:start-x padded-points))
         height              (- (:end-y padded-points) (:start-y padded-points))]
     (assoc padded-points
       :width width
       :height height
       :center {:x (+ (:start-x padded-points) (/ width 2))
                :y (+ (:start-y padded-points) (/ height 2))}))))

(def calculate-rect-memo (memoize calculate-rect))
